import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pallet } from '../stock-levels-model/stock-levels-modal.component';
import { PigeonholeDetails } from 'src/models/Pigeonhole';

export interface PigeonholeModalInterface {
  qrCode: string;
  selectedTabIndex?: number;
  scrollTo?: string;
}

@Component({
  selector: 'app-pigeonhole-modal',
  templateUrl: './pigeonhole-modal.component.html',
  styleUrls: ['./pigeonhole-modal.component.scss']
})
export class PigeonholeModalComponent implements OnInit {
  @Input() data: PigeonholeModalInterface;
  @Input() pigeonholeDetails: PigeonholeDetails & { group: string} ;
  @Input() packages: Pallet[] = [];
  @Output() changeToPallet = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  openPalletDetails(pallet: Pallet) {
    this.changeToPallet.emit(pallet);
  }

  handleCloseModalEvent(event: boolean) {
    if (event) {
      this.closeModal.emit(true);
    }
  }
}
